import { QueryClient } from "@tanstack/react-query";
import { retryUnlessConsent } from "@/lib/aiConsent";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: retryUnlessConsent(2),
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10_000),
      // MAV-126: when the user swipes back into the mini-app after a bot
      // command (`/admin_grant`, refund, referral reward) the cached
      // `useMe` data is stale and the paywall keeps showing the old
      // balance. React Query honours `staleTime` so non-stale caches
      // (LLM readings, etc.) still skip the refetch.
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: { retry: 0 },
  },
});
